<script lang="ts">import "../api/api";
import { formatLargeNumbers } from "../utils";
import { cfgBaseCurrencySymbol } from "@infinitro/config";
import { formatNumber, loggedIn, providerBasePath, toSiteUrl } from "@infinitro/global";
import { RemoteIcon } from "@infinitro/icons";
import { Text } from "@infinitro/text";
export let liveWin;
const truncate = (value, maxLength) => {
	return value.length > maxLength ? `${value.slice(0, maxLength - 3)}...` : value;
};
const formatGameTitle = () => {
	const title = liveWin.gameSlug.replace(/[_-]+/g, " ").split(" ").filter(Boolean).map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(" ");
	return truncate(title || "Unknown Game", 20);
};
const truncatedUsername = () => {
	return truncate(liveWin.username || "Anonymous", 14);
};
const formattedMultiplier = () => {
	return formatNumber(liveWin.multiplier, false, false, undefined, true);
};
const formattedPayout = () => {
	const symbol = cfgBaseCurrencySymbol();
	const amount = formatLargeNumbers(liveWin.paidCurrency);
	return symbol ? `${symbol}${amount}` : `${amount}`;
};
</script>

<div class="win-card-momentum">
	<div class="row-top">
		<a
			class="game-name"
			href={toSiteUrl(
				`${providerBasePath(liveWin.providerSlug)}${liveWin.providerSlug}/${liveWin.gameSlug}`,
				$loggedIn
			) || '#'}
			aria-label={`${formatGameTitle()} game`}
		>
			{formatGameTitle()}
		</a>
		<span class="username">{truncatedUsername()}</span>
	</div>
	<div class="row-bottom">
		<span class="multiplier-group">
			<span class="multiplier">{formattedMultiplier()}</span>
			<RemoteIcon icon="PopularIcon" size={14} color="var(--color-error-100)" />
		</span>
		<div class="payout">
			<Text
				type="body"
				bodySize="small"
				bodyWeight="bold"
				textColor="success-700"
				customStyle="padding-top: 2px;"
			>
				{formattedPayout()}
			</Text>
		</div>
	</div>
</div>

<style>
	.win-card-momentum {
		display: flex;
		height: 48px;
		width: 258px;
		flex-direction: column;
		justify-content: center;
		gap: 0.5rem;
		padding: 0px;
		border-right: 1px solid color-mix(in srgb, var(--color-text-100), transparent 80%);
		font-family: var(--font-main);
		padding-right: 12px
}

	.row-top,
	.row-bottom {
		display: flex;
		width: 100%;
		align-items: center;
		justify-content: space-between;
		gap: 0.5rem;
		line-height: 1
}

	.username,
	.game-name,
	.payout {
		display: block;
		min-width: 0px;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap
}

	.game-name,
	.username {
		height: 1.25rem;
		font-size: 14px;
		font-weight: 600;
		line-height: 140%;
		color: var(--color-text-100)
}

	.game-name {
		width: 140px;
		text-decoration-line: underline
}

	.username {
		width: 110px;
		text-align: right;
		opacity: 0.5
}

	.multiplier-group {
		display: inline-flex;
		height: 1.25rem;
		flex-shrink: 0;
		align-items: center;
		gap: 0.5rem
}

	.multiplier {
		height: 1.25rem;
		white-space: nowrap;
		font-size: 14px;
		font-weight: 600;
		line-height: 140%;
		color: var(--color-text-100)
}

	.payout {
		height: 1.25rem;
		max-width: 150px;
		flex-shrink: 0;
		text-align: right;
		font-size: 14px;
		font-weight: 600;
		line-height: 140%;
		color: var(--color-success-700)
}
</style>
